import { render } from "./AccountActivation.vue?vue&type=template&id=1e48b929"
import script from "./AccountActivation.vue?vue&type=script&lang=js"
export * from "./AccountActivation.vue?vue&type=script&lang=js"
script.render = render

export default script